export const PAGE_TITLE = "Volunteers";
export const PAGE_SINGLE_TITLE = "Volunteer";
export const LINK_URL = "volunteers";
export const SEARCH_TERMS = ["name", "phone", "email"];
export const inputFields = {
  name: {
    type: "string",
    required: true,
    title: "Name",
  },
  phone: {
    type: "string",
    required: true,
    title: "Phone",
  },
  email: {
    type: "string",
    required: true,
    title: "Email",
  },
  address: {
    type: "text",
    required: false,
    title: "Address",
  },
  remarks: {
    type: "text",
    required: false,
    title: "Remarks",
  },
};
export const initialValues = {
  name: "",
  phone: "",
  email: "",
  address: "",
  remarks: "",
};

export const view_all_table = [
  { name: "Name", value: "name" },
  { name: "Phone", value: "phone" },
  { name: "Email", value: "email" },
  { name: "Address", value: "address" },
];
